export default "__VITE_ASSET__C6c_j$iQ__"